module.exports = __webpack_public_path__ + "static/latacunga-8413f09bef0a7556535b0ba0edec2641.jpg";